import 'react-quill/dist/quill.snow.css';
import { Card } from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { FileDoneOutlined } from '@ant-design/icons';
import { FormQuestions } from './components/FormQuestions';
import { IAssessmentQuestion } from 'interfaces/assessments';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm } from '@refinedev/antd';

export const AssessmentQuestionCreate = () => {
  const form = useForm<IAssessmentQuestion>({
    redirect: 'edit',
    errorNotification: (error, values) => {
      const question = values as IAssessmentQuestion;

      if (!question.correct_alternative_id) {
        return {
          description: 'Alternativa correta',
          message: 'É necessário informar uma alternativa correta',
          type: 'error'
        };
      }

      return {
        description: 'Ops! Algo de errado',
        message: 'Não foi possível criar a questão. Tente novamente',
        type: 'error'
      };
    }
  });

  return (
    <CreateLayout saveButtonProps={form.saveButtonProps}>
      <PageHeader title="Nova Questão" icon={FileDoneOutlined} />
      <Card>
        <FormQuestions formInstance={form} />
      </Card>
    </CreateLayout>
  );
};
